import * as React from 'react';

// hooks for firing mount/unmount and not writing all the time disabling eslint deps for React.useEffect

const useMount = (fn: React.EffectCallback): void => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(fn, []);
};

export default useMount;
